import { render, staticRenderFns } from "./paymentList.vue?vue&type=template&id=0bce3f1a"
import script from "./paymentList.vue?vue&type=script&lang=js"
export * from "./paymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports